export const ActionTypes = {
  FETCH_VISION_EQUIPMENT:
    'services/dashboards/vision/visionEquipmentDashboard/fetch_vision_equipment',
  SET_VISION_EQUIPMENT:
    'services/dashboards/vision/visionEquipmentDashboard/set_vision_equipment',
  SET_LOADER_STATUS:
    'services/dashboards/vision/visionEquipmentDashboard/set_loader_status',
};

const fetchVisionEquipment = ({ visionEquipmentParams }) => ({
  visionEquipmentParams,
  type: ActionTypes.FETCH_VISION_EQUIPMENT,
});

const setVisionEquipment = ({ visionEquipmentData }) => ({
  visionEquipmentData,
  type: ActionTypes.SET_VISION_EQUIPMENT,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchVisionEquipment,
  setVisionEquipment,
  setLoader,
};
